export const translations = {
  en: {
    // NAVBAR
    nav_how: "How it works",
    nav_guide: "Visa Guide",
    nav_visas: "Visa categories",
    nav_contact: "Contact Us",
    nav_cta: "Check eligibility →",
    nav_back: "← Back to home",

    // HERO
    hero_badge: "FREE VISA ELIGIBILITY CHECKER",
    hero_headline: "Find your path to Portugal",
    hero_sub: "Every person deserves a clear path to Portugal — regardless of where they come from.",
    hero_cta: "Check my visa eligibility →",
    hero_trust: "Used by 500+ immigrants · Updated April 2026 · Free forever",

    // HOW IT WORKS
    how_label: "HOW IT WORKS",
    how_title: "Your visa answer in 3 steps",
    step1_badge: "Step 01",
    step1_title: "Answer 3 quick questions",
    step1_desc: "Tell us why you're moving and a few details about your situation. Takes under 2 minutes.",
    step2_badge: "Step 02",
    step2_title: "See which visa you qualify for",
    step2_desc: "We match your answers to Portugal's current visa rules and show you the exact path forward.",
    step3_badge: "Step 03",
    step3_title: "Connect with a verified lawyer",
    step3_desc: "Ready to apply? We'll connect you with a vetted immigration lawyer who knows your visa type.",
    start_checker: "Start the checker →",

    // VISA CATEGORIES
    visas_label: "VISA CATEGORIES",
    visas_title: "8 pathways to Portuguese residency",
    visas_sub: "We cover every major visa route. The checker tells you exactly which one fits your situation.",

    // FOOTER
    footer_legal: "Bideshai provides general immigration information only. Nothing on this platform constitutes legal advice. Always consult a qualified immigration lawyer for your specific situation. Visa rules change frequently — verify all information with AIMA or the Portuguese Ministry of Foreign Affairs before applying.",
    footer_built: "Built in Viseu, Portugal 🇵🇹 · Updated April 2026 · All rights reserved",

    // CHECKER
    checker_question: "Why are you moving to Portugal?",
    checker_hint: "Select the option that best describes your situation",
    checker_not_sure: "Not sure? A verified lawyer can assess your exact situation.",
    checker_back: "← Back",
    checker_start_over: "← Start over",
    checker_step: "Step",
    checker_of: "of",

    // OPTIONS
    opt_remote: "I work remotely",
    opt_retire: "I want to retire / I have passive income",
    opt_business: "I want to start a business",
    opt_job: "I have a job offer",
    opt_study: "I want to study",
    opt_invest: "I want to invest capital",
    opt_family: "I want to join my family",
    opt_employed: "Employed by a company (remote)",
    opt_freelance: "Freelance / self-employed",
    opt_yes_income_d8: "Yes, I earn €3,480/month or more",
    opt_no_income_d8: "No, my income is below this",
    opt_yes_income_d7: "Yes, I receive €870/month or more",
    opt_no_income_d7: "No, my passive income is lower",
    opt_established: "Established business / freelance professional",
    opt_startup: "Innovative startup idea",
    opt_yes_incubator: "Yes, I have an incubator partner",
    opt_no_incubator: "No, not yet",
    opt_yes_skilled: "Yes — I am a highly skilled professional",
    opt_yes_any: "Yes — any role",
    opt_no_employer: "No — employer is outside Portugal",
    opt_long_study: "More than 1 year (university, long course)",
    opt_short_study: "Less than 1 year (short course / exchange)",
    opt_invest_250: "€250,000 or more (cultural/heritage)",
    opt_invest_500: "€500,000 or more (investment fund / R&D)",
    opt_invest_low: "Below €250,000",
    opt_yes_sponsor: "Yes — they have a valid residence permit",
    opt_no_sponsor: "No",

    // QUESTION HINTS
    hint_d8_employed: "Both can qualify for the D8 Digital Nomad Visa",
    hint_d8_income: "This is 4× Portugal's minimum wage — the required D8 threshold",
    hint_d7_income: "This is Portugal's minimum wage — the D7 income threshold",
    hint_business: "Portugal has two distinct entrepreneur pathways",
    hint_incubator: "The Startup Visa requires a certified incubator partner",
    hint_employer: "This determines whether you need a D1 or D3 work visa",
    hint_study: "Duration determines which study visa applies",
    hint_invest: "Portugal's Golden Visa has a minimum threshold of €250,000",
    hint_family: "The sponsor must hold a valid Portuguese residence permit",
    hint_employed: "This helps determine if you qualify for the D8 Digital Nomad Visa",

    // RESULT
    result_match: "✓ Visa match found",
    result_warning: "⚠ Action needed before applying",
    result_key_points: "KEY POINTS",
    result_important: "IMPORTANT — READ BEFORE APPLYING",
    result_documents: "DOCUMENTS YOU WILL NEED",
    result_income: "MIN INCOME / INVESTMENT",
    result_timeline: "ESTIMATED TIMELINE",
    result_cost: "ESTIMATED COST",
    result_path: "PATH FORWARD",
    result_alternatives: "CONSIDER THESE ALTERNATIVES",

    // LAWYER CTA
    lawyer_title: "Get matched with a lawyer",
    lawyer_sub: "We're building a verified network of immigration lawyers in Portugal. Leave your details and we'll match you personally.",
    lawyer_name: "YOUR NAME",
    lawyer_email: "YOUR EMAIL",
    lawyer_btn: "Get matched with a lawyer →",
    lawyer_trust: "Free. No commitment. We'll contact you within 48 hours.",
    lawyer_success_title: "You're on the list",
    lawyer_success_sub: "We'll match you with a verified lawyer and be in touch within 48 hours.",
    lawyer_talk: "Talk to a lawyer →",

    // DISCLAIMER
    disclaimer: "This result is a guide only, not legal advice. Immigration rules change frequently. Always verify current requirements with AIMA or a qualified lawyer before applying. Last updated: April 2026.",

    // EXTRA CHECKER QUESTIONS
    q_employment_type_text: "Are you employed by a company or freelance?",
    q_d8_income_text: "Do you earn at least €3,480/month consistently over the last 6–12 months?",
    q_passive_income_text: "Do you receive at least €870/month from pension, investments, or rental income?",
    q_business_type_text: "What kind of business do you want to start?",
    q_incubator_text: "Do you have a partnership with an IAPMEI-certified Portuguese incubator?",
    q_employer_location_text: "Is your employer a Portuguese company?",
    q_study_duration_text: "How long is your course or program?",
    q_investment_amount_text: "What is your available investment amount?",
    q_sponsor_status_text: "Is your family member already a legal resident in Portugal?",

    // EXTRA LANDING
    contact_label: "Contact us",
    contact_title: "Have a question? We're here.",
    contact_sub: "Reach out via WhatsApp or email and we'll point you in the right direction — no commitment required.",
    visa_d7_name: "Passive Income",
    visa_d7_tagline: "Retirees & pension holders",
    visa_d8_name: "Digital Nomad",
    visa_d8_tagline: "Remote workers €3,480+/mo",
    visa_d2_name: "Entrepreneur",
    visa_d2_tagline: "Founders & freelancers",
    visa_d3_name: "Highly Qualified",
    visa_d3_tagline: "Skilled workers + EU Blue Card",
    visa_d1_name: "Employed Worker",
    visa_d1_tagline: "Any role with PT job offer",
    visa_d4_name: "Student",
    visa_d4_tagline: "Universities & long courses",
    visa_d6_name: "Family Reunification",
    visa_d6_tagline: "Join a Portuguese resident",
    visa_ari_name: "Golden Visa",
    visa_ari_tagline: "Investors from €250,000",

    // EXTRA MESSAGES
    checker_badge: "Visa Checker",
    loading_app: "Loading…",
    matching_you: "Matching you...",
    submit_error: "Something went wrong. Please try again.",
  },

  bn: {
    // NAVBAR
    nav_how: "কীভাবে কাজ করে",
    nav_guide: "ভিসা গাইড",
    nav_visas: "ভিসা ক্যাটাগরি",
    nav_contact: "যোগাযোগ",
    nav_cta: "যোগ্যতা যাচাই করুন →",
    nav_back: "← হোমে ফিরুন",

    // HERO
    hero_badge: "বিনামূল্যে ভিসা যোগ্যতা পরীক্ষক",
    hero_headline: "পর্তুগালে আপনার পথ খুঁজুন",
    hero_sub: "প্রত্যেক মানুষ পর্তুগালে একটি স্পষ্ট পথ পাওয়ার যোগ্য — যেখান থেকেই আসুক না কেন।",
    hero_cta: "আমার ভিসা যোগ্যতা যাচাই করুন →",
    hero_trust: "৫০০+ অভিবাসী ব্যবহার করেছেন · আপডেট: এপ্রিল ২০২৬ · সম্পূর্ণ বিনামূল্যে",

    // HOW IT WORKS
    how_label: "কীভাবে কাজ করে",
    how_title: "৩টি ধাপে আপনার ভিসার উত্তর",
    step1_badge: "ধাপ ০১",
    step1_title: "৩টি দ্রুত প্রশ্নের উত্তর দিন",
    step1_desc: "আপনি কেন যাচ্ছেন এবং পরিস্থিতি সম্পর্কে কিছু তথ্য দিন। ২ মিনিটের কম সময় লাগবে।",
    step2_badge: "ধাপ ০২",
    step2_title: "আপনি কোন ভিসার যোগ্য দেখুন",
    step2_desc: "আমরা আপনার উত্তর পর্তুগালের বর্তমান ভিসা নিয়মের সাথে মিলিয়ে সঠিক পথ দেখাই।",
    step3_badge: "ধাপ ০৩",
    step3_title: "যাচাইকৃত আইনজীবীর সাথে যোগাযোগ করুন",
    step3_desc: "আবেদন করতে প্রস্তুত? আমরা আপনার ভিসা বিশেষজ্ঞ একজন আইনজীবীর সাথে সংযুক্ত করব।",
    start_checker: "চেকার শুরু করুন →",

    // VISA CATEGORIES
    visas_label: "ভিসা ক্যাটাগরি",
    visas_title: "পর্তুগিজ বাসস্থানের ৮টি পথ",
    visas_sub: "আমরা প্রতিটি প্রধান ভিসা রুট কভার করি। চেকার আপনাকে বলবে কোনটি আপনার জন্য সঠিক।",

    // FOOTER
    footer_legal: "বিদেশাই শুধুমাত্র সাধারণ অভিবাসন তথ্য প্রদান করে। এই প্ল্যাটফর্মের কিছুই আইনি পরামর্শ নয়। আবেদনের আগে সর্বদা একজন যোগ্য আইনজীবীর সাথে পরামর্শ করুন।",
    footer_built: "পর্তুগালের ভিসেউ থেকে তৈরি 🇵🇹 · আপডেট: এপ্রিল ২০২৬",

    // CHECKER
    checker_question: "আপনি কেন পর্তুগালে যেতে চান?",
    checker_hint: "আপনার পরিস্থিতি সবচেয়ে ভালো বর্ণনা করে এমন বিকল্পটি বেছে নিন",
    checker_not_sure: "নিশ্চিত নন? একজন যাচাইকৃত আইনজীবী আপনার পরিস্থিতি মূল্যায়ন করতে পারবেন।",
    checker_back: "← ফিরে যান",
    checker_start_over: "← আবার শুরু করুন",
    checker_step: "ধাপ",
    checker_of: "এর মধ্যে",

    // OPTIONS
    opt_remote: "আমি দূর থেকে কাজ করি",
    opt_retire: "আমি অবসর নিতে চাই / আমার প্যাসিভ আয় আছে",
    opt_business: "আমি ব্যবসা শুরু করতে চাই",
    opt_job: "আমার চাকরির অফার আছে",
    opt_study: "আমি পড়াশোনা করতে চাই",
    opt_invest: "আমি বিনিয়োগ করতে চাই",
    opt_family: "আমি পরিবারের সাথে যোগ দিতে চাই",
    opt_employed: "একটি কোম্পানিতে চাকরি করি (দূরবর্তী)",
    opt_freelance: "ফ্রিল্যান্স / স্ব-নিযুক্ত",
    opt_yes_income_d8: "হ্যাঁ, আমি মাসে €৩,৪৮০ বা বেশি আয় করি",
    opt_no_income_d8: "না, আমার আয় এর চেয়ে কম",
    opt_yes_income_d7: "হ্যাঁ, আমি মাসে €৮৭০ বা বেশি পাই",
    opt_no_income_d7: "না, আমার প্যাসিভ আয় কম",
    opt_established: "প্রতিষ্ঠিত ব্যবসা / ফ্রিল্যান্স পেশাদার",
    opt_startup: "উদ্ভাবনী স্টার্টআপ আইডিয়া",
    opt_yes_incubator: "হ্যাঁ, আমার ইনকিউবেটর পার্টনার আছে",
    opt_no_incubator: "না, এখনো নেই",
    opt_yes_skilled: "হ্যাঁ — আমি একজন উচ্চ দক্ষ পেশাদার",
    opt_yes_any: "হ্যাঁ — যেকোনো পদে",
    opt_no_employer: "না — নিয়োগকর্তা পর্তুগালের বাইরে",
    opt_long_study: "১ বছরের বেশি (বিশ্ববিদ্যালয়, দীর্ঘ কোর্স)",
    opt_short_study: "১ বছরের কম (স্বল্পমেয়াদী কোর্স)",
    opt_invest_250: "€২৫০,০০০ বা বেশি (সাংস্কৃতিক/ঐতিহ্য)",
    opt_invest_500: "€৫০০,০০০ বা বেশি (বিনিয়োগ ফান্ড)",
    opt_invest_low: "€২৫০,০০০ এর নিচে",
    opt_yes_sponsor: "হ্যাঁ — তাদের বৈধ বাসস্থানের অনুমতি আছে",
    opt_no_sponsor: "না",

    // QUESTION HINTS
    hint_d8_employed: "উভয়ই D8 ডিজিটাল নোমাড ভিসার জন্য যোগ্য হতে পারে",
    hint_d8_income: "এটি পর্তুগালের ন্যূনতম মজুরির ৪ গুণ — D8 আয়ের সীমা",
    hint_d7_income: "এটি পর্তুগালের ন্যূনতম মজুরি — D7 আয়ের সীমা",
    hint_business: "পর্তুগালে উদ্যোক্তাদের জন্য দুটি আলাদা পথ আছে",
    hint_incubator: "স্টার্টআপ ভিসার জন্য একটি স্বীকৃত ইনকিউবেটর পার্টনার প্রয়োজন",
    hint_employer: "এটি নির্ধারণ করে আপনার D1 নাকি D3 ভিসা প্রয়োজন",
    hint_study: "সময়কাল নির্ধারণ করে কোন স্টুডেন্ট ভিসা প্রযোজ্য",
    hint_invest: "পর্তুগালের গোল্ডেন ভিসার ন্যূনতম সীমা €২৫০,০০০",
    hint_family: "স্পনসরের অবশ্যই বৈধ পর্তুগিজ বাসস্থানের অনুমতি থাকতে হবে",
    hint_employed: "এটি নির্ধারণ করতে সাহায্য করে আপনি D8 ভিসার যোগ্য কিনা",

    // RESULT
    result_match: "✓ ভিসা পাওয়া গেছে",
    result_warning: "⚠ আবেদনের আগে পদক্ষেপ প্রয়োজন",
    result_key_points: "মূল বিষয়সমূহ",
    result_important: "গুরুত্বপূর্ণ — আবেদনের আগে পড়ুন",
    result_documents: "প্রয়োজনীয় কাগজপত্র",
    result_income: "ন্যূনতম আয় / বিনিয়োগ",
    result_timeline: "আনুমানিক সময়কাল",
    result_cost: "আনুমানিক খরচ",
    result_path: "পরবর্তী পথ",
    result_alternatives: "বিকল্প ভিসা বিবেচনা করুন",

    // LAWYER CTA
    lawyer_title: "একজন আইনজীবীর সাথে যুক্ত হন",
    lawyer_sub: "আমরা পর্তুগালে যাচাইকৃত অভিবাসন আইনজীবীদের একটি নেটওয়ার্ক তৈরি করছি। আপনার তথ্য দিন এবং আমরা ব্যক্তিগতভাবে মিলিয়ে দেব।",
    lawyer_name: "আপনার নাম",
    lawyer_email: "আপনার ইমেইল",
    lawyer_btn: "আইনজীবীর সাথে যুক্ত হন →",
    lawyer_trust: "বিনামূল্যে। কোনো প্রতিশ্রুতি নেই। আমরা ৪৮ ঘণ্টার মধ্যে যোগাযোগ করব।",
    lawyer_success_title: "তালিকায় যোগ হয়েছেন",
    lawyer_success_sub: "আমরা আপনাকে একজন যাচাইকৃত আইনজীবীর সাথে মিলিয়ে ৪৮ ঘণ্টার মধ্যে যোগাযোগ করব।",
    lawyer_talk: "আইনজীবীর সাথে কথা বলুন →",

    // DISCLAIMER
    disclaimer: "এই ফলাফল শুধুমাত্র একটি গাইড, আইনি পরামর্শ নয়। অভিবাসন নিয়ম প্রায়ই পরিবর্তন হয়। আবেদনের আগে সর্বদা AIMA বা একজন যোগ্য আইনজীবীর সাথে যাচাই করুন। সর্বশেষ আপডেট: এপ্রিল ২০২৬।",

    // EXTRA CHECKER QUESTIONS
    q_employment_type_text: "আপনি কি একটি কোম্পানিতে চাকরি করেন নাকি ফ্রিল্যান্স?",
    q_d8_income_text: "গত ৬–১২ মাসে আপনি কি নিয়মিত কমপক্ষে €৩,৪৮০/মাস উপার্জন করেন?",
    q_passive_income_text: "পেনশন, বিনিয়োগ বা ভাড়া থেকে কি আপনি কমপক্ষে €৮৭০/মাস পান?",
    q_business_type_text: "আপনি কী ধরনের ব্যবসা শুরু করতে চান?",
    q_incubator_text: "আপনার কি IAPMEI-স্বীকৃত পর্তুগিজ ইনকিউবেটরের সাথে অংশীদারিত্ব আছে?",
    q_employer_location_text: "আপনার নিয়োগকর্তা কি পর্তুগিজ কোম্পানি?",
    q_study_duration_text: "আপনার কোর্স বা প্রোগ্রামের সময়কাল কত?",
    q_investment_amount_text: "আপনার বিনিয়োগের পরিমাণ কত?",
    q_sponsor_status_text: "আপনার পরিবারের সদস্য কি ইতিমধ্যে পর্তুগালে বৈধ বাসিন্দা?",

    // EXTRA LANDING
    contact_label: "যোগাযোগ",
    contact_title: "প্রশ্ন আছে? আমরা আছি।",
    contact_sub: "হোয়াটসঅ্যাপ বা ইমেইলে যোগাযোগ করুন, আমরা আপনাকে সঠিক দিক দেখাব — কোনো বাধ্যবাধকতা নেই।",
    visa_d7_name: "প্যাসিভ ইনকাম",
    visa_d7_tagline: "অবসরপ্রাপ্ত ও পেনশনধারী",
    visa_d8_name: "ডিজিটাল নোমাড",
    visa_d8_tagline: "রিমোট কর্মী €৩,৪৮০+/মাস",
    visa_d2_name: "উদ্যোক্তা",
    visa_d2_tagline: "প্রতিষ্ঠাতা ও ফ্রিল্যান্সার",
    visa_d3_name: "উচ্চ দক্ষ পেশাজীবী",
    visa_d3_tagline: "দক্ষ কর্মী + EU ব্লু কার্ড",
    visa_d1_name: "নিয়োজিত কর্মী",
    visa_d1_tagline: "পর্তুগালে চাকরির অফারসহ যেকোনো ভূমিকা",
    visa_d4_name: "স্টুডেন্ট",
    visa_d4_tagline: "বিশ্ববিদ্যালয় ও দীর্ঘমেয়াদী কোর্স",
    visa_d6_name: "পারিবারিক পুনর্মিলন",
    visa_d6_tagline: "পর্তুগালে বসবাসরত পরিবারের সঙ্গে যোগ দিন",
    visa_ari_name: "গোল্ডেন ভিসা",
    visa_ari_tagline: "€২৫০,০০০ থেকে বিনিয়োগকারী",

    // EXTRA MESSAGES
    checker_badge: "ভিসা চেকার",
    loading_app: "লোড হচ্ছে…",
    matching_you: "ম্যাচ করা হচ্ছে...",
    submit_error: "কিছু ভুল হয়েছে। আবার চেষ্টা করুন।",
  },

  pt: {
    // NAVBAR
    nav_how: "Como funciona",
    nav_guide: "Guia de Vistos",
    nav_visas: "Categorias de visto",
    nav_contact: "Contacto",
    nav_cta: "Verificar elegibilidade →",
    nav_back: "← Voltar ao início",

    // HERO
    hero_badge: "VERIFICADOR DE ELEGIBILIDADE GRATUITO",
    hero_headline: "Encontre o seu caminho para Portugal",
    hero_sub: "Toda pessoa merece um caminho claro para Portugal — independentemente de onde venha.",
    hero_cta: "Verificar a minha elegibilidade →",
    hero_trust: "Usado por 500+ imigrantes · Atualizado abril 2026 · Sempre gratuito",

    // HOW IT WORKS
    how_label: "COMO FUNCIONA",
    how_title: "A sua resposta de visto em 3 passos",
    step1_badge: "Passo 01",
    step1_title: "Responda 3 perguntas rápidas",
    step1_desc: "Diga-nos por que está a mudar-se e alguns detalhes sobre a sua situação. Menos de 2 minutos.",
    step2_badge: "Passo 02",
    step2_title: "Veja para que visto se qualifica",
    step2_desc: "Combinamos as suas respostas com as regras de visto atuais de Portugal e mostramos o caminho.",
    step3_badge: "Passo 03",
    step3_title: "Conecte-se com um advogado verificado",
    step3_desc: "Pronto para candidatar? Vamos conectá-lo com um advogado especialista no seu tipo de visto.",
    start_checker: "Iniciar o verificador →",

    // VISA CATEGORIES
    visas_label: "CATEGORIAS DE VISTO",
    visas_title: "8 caminhos para a residência portuguesa",
    visas_sub: "Cobrimos todas as principais rotas de visto. O verificador diz-lhe exatamente qual se adequa à sua situação.",

    // FOOTER
    footer_legal: "A Bideshai fornece apenas informações gerais sobre imigração. Nada nesta plataforma constitui aconselhamento jurídico. Consulte sempre um advogado qualificado para a sua situação específica. As regras de visto mudam frequentemente — verifique todas as informações com a AIMA antes de candidatar.",
    footer_built: "Construído em Viseu, Portugal 🇵🇹 · Atualizado abril 2026 · Todos os direitos reservados",

    // CHECKER
    checker_question: "Por que razão se muda para Portugal?",
    checker_hint: "Selecione a opção que melhor descreve a sua situação",
    checker_not_sure: "Não tem certeza? Um advogado verificado pode avaliar a sua situação.",
    checker_back: "← Voltar",
    checker_start_over: "← Recomeçar",
    checker_step: "Passo",
    checker_of: "de",

    // OPTIONS
    opt_remote: "Trabalho remotamente",
    opt_retire: "Quero reformar-me / tenho rendimentos passivos",
    opt_business: "Quero iniciar um negócio",
    opt_job: "Tenho uma oferta de emprego",
    opt_study: "Quero estudar",
    opt_invest: "Quero investir capital",
    opt_family: "Quero juntar-me à minha família",
    opt_employed: "Empregado numa empresa (remoto)",
    opt_freelance: "Freelancer / trabalhador independente",
    opt_yes_income_d8: "Sim, ganho €3.480/mês ou mais",
    opt_no_income_d8: "Não, o meu rendimento é inferior",
    opt_yes_income_d7: "Sim, recebo €870/mês ou mais",
    opt_no_income_d7: "Não, o meu rendimento passivo é inferior",
    opt_established: "Negócio estabelecido / profissional independente",
    opt_startup: "Ideia de startup inovadora",
    opt_yes_incubator: "Sim, tenho um parceiro incubador",
    opt_no_incubator: "Não, ainda não",
    opt_yes_skilled: "Sim — sou um profissional altamente qualificado",
    opt_yes_any: "Sim — qualquer função",
    opt_no_employer: "Não — empregador fora de Portugal",
    opt_long_study: "Mais de 1 ano (universidade, curso longo)",
    opt_short_study: "Menos de 1 ano (curso curto / intercâmbio)",
    opt_invest_250: "€250.000 ou mais (cultural/patrimonial)",
    opt_invest_500: "€500.000 ou mais (fundo de investimento)",
    opt_invest_low: "Abaixo de €250.000",
    opt_yes_sponsor: "Sim — têm uma autorização de residência válida",
    opt_no_sponsor: "Não",

    // QUESTION HINTS
    hint_d8_employed: "Ambos podem qualificar-se para o Visto D8 Nómada Digital",
    hint_d8_income: "Este é 4× o salário mínimo português — o limite exigido para o D8",
    hint_d7_income: "Este é o salário mínimo português — o limite para o D7",
    hint_business: "Portugal tem dois caminhos distintos para empreendedores",
    hint_incubator: "O Visto Startup requer um parceiro incubador certificado",
    hint_employer: "Isso determina se precisa de um visto D1 ou D3",
    hint_study: "A duração determina qual visto de estudo se aplica",
    hint_invest: "O Golden Visa de Portugal tem um limite mínimo de €250.000",
    hint_family: "O patrocinador deve ter uma autorização de residência portuguesa válida",
    hint_employed: "Isso ajuda a determinar se se qualifica para o Visto D8",

    // RESULT
    result_match: "✓ Visto encontrado",
    result_warning: "⚠ Ação necessária antes de candidatar",
    result_key_points: "PONTOS CHAVE",
    result_important: "IMPORTANTE — LEIA ANTES DE CANDIDATAR",
    result_documents: "DOCUMENTOS QUE VAI PRECISAR",
    result_income: "RENDIMENTO MÍN. / INVESTIMENTO",
    result_timeline: "PRAZO ESTIMADO",
    result_cost: "CUSTO ESTIMADO",
    result_path: "CAMINHO A SEGUIR",
    result_alternatives: "CONSIDERE ESTAS ALTERNATIVAS",

    // LAWYER CTA
    lawyer_title: "Seja correspondido com um advogado",
    lawyer_sub: "Estamos a construir uma rede verificada de advogados de imigração em Portugal. Deixe os seus dados e faremos a correspondência pessoalmente.",
    lawyer_name: "O SEU NOME",
    lawyer_email: "O SEU EMAIL",
    lawyer_btn: "Ser correspondido com um advogado →",
    lawyer_trust: "Gratuito. Sem compromisso. Entraremos em contacto em 48 horas.",
    lawyer_success_title: "Está na lista",
    lawyer_success_sub: "Vamos correspondê-lo com um advogado verificado e entrar em contacto em 48 horas.",
    lawyer_talk: "Falar com um advogado →",

    // DISCLAIMER
    disclaimer: "Este resultado é apenas um guia, não aconselhamento jurídico. As regras de imigração mudam frequentemente. Verifique sempre os requisitos atuais com a AIMA ou um advogado qualificado antes de candidatar. Última atualização: abril 2026.",

    // EXTRA CHECKER QUESTIONS
    q_employment_type_text: "Está empregado por uma empresa ou é freelancer?",
    q_d8_income_text: "Ganha pelo menos €3.480/mês de forma consistente nos últimos 6–12 meses?",
    q_passive_income_text: "Recebe pelo menos €870/mês de pensão, investimentos ou renda?",
    q_business_type_text: "Que tipo de negócio quer iniciar?",
    q_incubator_text: "Tem parceria com uma incubadora portuguesa certificada pela IAPMEI?",
    q_employer_location_text: "O seu empregador é uma empresa portuguesa?",
    q_study_duration_text: "Qual é a duração do seu curso ou programa?",
    q_investment_amount_text: "Qual é o valor disponível para investimento?",
    q_sponsor_status_text: "O seu familiar já é residente legal em Portugal?",

    // EXTRA LANDING
    contact_label: "Contacto",
    contact_title: "Tem uma pergunta? Estamos aqui.",
    contact_sub: "Fale connosco por WhatsApp ou email e orientamos o melhor caminho — sem compromisso.",
    visa_d7_name: "Rendimento Passivo",
    visa_d7_tagline: "Reformados e pensionistas",
    visa_d8_name: "Nómada Digital",
    visa_d8_tagline: "Trabalhadores remotos €3.480+/mês",
    visa_d2_name: "Empreendedor",
    visa_d2_tagline: "Fundadores e freelancers",
    visa_d3_name: "Altamente Qualificado",
    visa_d3_tagline: "Profissionais qualificados + Cartão Azul UE",
    visa_d1_name: "Trabalhador Empregado",
    visa_d1_tagline: "Qualquer função com oferta em PT",
    visa_d4_name: "Estudante",
    visa_d4_tagline: "Universidades e cursos longos",
    visa_d6_name: "Reagrupamento Familiar",
    visa_d6_tagline: "Junte-se a um residente em Portugal",
    visa_ari_name: "Golden Visa",
    visa_ari_tagline: "Investidores desde €250.000",

    // EXTRA MESSAGES
    checker_badge: "Verificador de Visto",
    loading_app: "A carregar…",
    matching_you: "A fazer correspondência...",
    submit_error: "Algo correu mal. Tente novamente.",
  }
};
